var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuActivitiesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M3.55556 5.33332H12.4444V10.6667H3.55556V5.33332ZM14.6667 7.99999C14.6667 8.73638 15.2636 9.33332 16 9.33332V12C16 12.7364 15.4031 13.3333 14.6667 13.3333H1.33333C0.596944 13.3333 0 12.7364 0 12V9.33332C0.736389 9.33332 1.33333 8.73638 1.33333 7.99999C1.33333 7.2636 0.736389 6.66666 0 6.66666V3.99999C0 3.2636 0.596944 2.66666 1.33333 2.66666H14.6667C15.4031 2.66666 16 3.2636 16 3.99999V6.66666C15.2636 6.66666 14.6667 7.2636 14.6667 7.99999ZM13.3333 5.1111C13.3333 4.74291 13.0349 4.44443 12.6667 4.44443H3.33333C2.96514 4.44443 2.66667 4.74291 2.66667 5.1111V10.8889C2.66667 11.2571 2.96514 11.5555 3.33333 11.5555H12.6667C13.0349 11.5555 13.3333 11.2571 13.3333 10.8889V5.1111Z",
    fill: "#9FA2B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuActivitiesIcon);
export default __webpack_public_path__ + "static/media/menu-activities-icon.835a8c8d5af3ca1e719e7072a0783e21.svg";
export { ForwardRef as ReactComponent };